import React from 'react';
import { motion } from 'framer-motion';
import { CreditCard, Mail, BookOpen } from 'lucide-react';
export function StepGuide() {
  const steps = [{
    icon: CreditCard,
    title: '1. Realizás el pago seguro',
    description: 'Utilizamos Mercado Pago como plataforma de cobros, por lo que tu pago está protegido, podés pagar con dinero en cuenta, o si no tenés cuenta allí no te preocupes, podés pagar igualmente con tarjeta de débito/crédito.',
    color: 'blue'
  }, {
    icon: Mail,
    title: '2. Recibís un email',
    description: 'En menos de 2 minutos, te llega un correo electrónico con tu manual listo para abrir.',
    color: 'green'
  }, {
    icon: BookOpen,
    title: '3. Empezás a aprender',
    description: 'Abrís el manual en tu celular o computadora y seguís los pasos a tu propio ritmo.',
    color: 'orange'
  }];
  return <div className="space-y-8" data-id="element-29">
      {steps.map((step, index) => <motion.div key={index} initial={{
      opacity: 0,
      y: 20
    }} whileInView={{
      opacity: 1,
      y: 0
    }} viewport={{
      once: true
    }} transition={{
      delay: index * 0.2
    }} className="flex gap-6 items-start bg-white p-6 rounded-2xl border border-slate-100 shadow-sm" data-id="element-30">
          <div className={`flex-shrink-0 w-12 h-12 rounded-full bg-${step.color}-100 flex items-center justify-center text-${step.color}-600 font-bold text-xl`} data-id="element-31">
            {index + 1}
          </div>
          <div data-id="element-32">
            <h3 className="text-xl font-bold text-slate-900 mb-2" data-id="element-33">
              {step.title}
            </h3>
            <p className="text-slate-600 leading-relaxed" data-id="element-34">{step.description}</p>
          </div>
        </motion.div>)}
    </div>;
}